import React, { useEffect, useRef, useCallback } from 'react';
import { saveHolidayBannerHeight } from '../../../modules/actions/couponBannerHeight';
import { useDispatch } from 'react-redux';

function HolidayBanner() {
    const startDate = new Date('2023-12-08T00:00:00+01:00');
    const endDate = new Date('2023-12-31T00:00:00+01:00');
    const ref = useRef(null);
    const dispatch = useDispatch();


    const onResize = useCallback(() => {
        if (ref.current) dispatch(saveHolidayBannerHeight(ref.current.clientHeight ?? 0));
    }, []);

    useEffect(() => {
        window.addEventListener("resize", onResize);
        onResize();
        return () => {
            window.removeEventListener("resize", onResize);
        };
    }, []);


    if (!(new Date() <= endDate)) return null;

    return (
        <>
            {!(new Date() <= startDate) && (
                <div ref={ref}
                    className="aps-corona-banner uk-tile uk-padding-small uk-padding-remove-horizontal uk-animation-fade uk-sticky-fixed uk-width-1-1"
                    style={{ backgroundColor: '#cc0099', color: 'white' }}
                >
                    <div className="uk-container">
                        <div className="uk-grid uk-flex-top">
                            <div className="uk-width-expand uk-text-light uk-text-center" style={{ fontSize: '18px', fontWeight: 'bold' }}>
                            Achtung: Längere Lieferzeiten während der Feiertage möglich
                            </div>
                            {/* <div className="uk-width-auto">
                        <button data-uk-toggle="target: .aps-corona-banner" data-uk-close="" />
                    </div> */}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default HolidayBanner;
